<template>
  <div>
    <router-view></router-view>
    <div
      class="toast"
      v-if="showTips"
    >
      <div class="modal">
        <div
          class="close"
          @click="closeHandler"
        >✖</div>
        <div class="title">Tips</div>
        <div class="content">{{tips}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Events, emitter } from './common/mitt';
export default {
  name: 'App',
  components: {
  }, data () {
    return {
      index: 0,
      tips: "",
      showTips: false,
    }
  },
  mounted () {

    emitter.on(Events.EventMin, this.showToasthandler);
  },
  methods: {
    showToasthandler (tips) {
      console.log('showToasthandler'); this.tips = tips;
      this.showTips = true;
    },
    closeHandler () {
      this.showTips = false;
    }
  }
}
</script>
<style lang="scss">
.toast {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  .modal {
    transition: opacity 100ms linear;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
    opacity: 1;
    width: 100%;
    margin: 0 auto;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
    background-color: white;
    position: relative;

    .title {
      height: 20px;
      right: 10px;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 23px;
      font-weight: bold;
      position: absolute;
    }
    .content {
      margin-top: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .close {
      width: 30px;
      height: 20px;
      right: 10px;
      top: 10px;
      cursor: pointer;
      position: absolute;
    }
  }
}
.btn {
  cursor: pointer;
  transition: all 0.25s linear;
}

.btn:hover {
  transform: scale(1.1);
}

.small-btn {
  cursor: pointer;
  transition: all 0.25s linear;
}

.small-btn:hover {
  transform: scale(1.03);
}
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  background: url('./assets/bgblur.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}

.flex {
  display: flex;
}

.space-between {
  justify-content: space-between;
}

.align-items {
  align-items: center;
}

html,
body {
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
</style>
